<template>
    <div>
        <my-form 
        class="form-page" 
        v-model="form" 
        table 
        label-width="180px" 
        @cancle="cancleHandler" 
        :submit-url="getUrl">
            <el-form-item 
            v-if="glbdShow&&glbdList.length>0"
            label="关联标段信息" 
            class="table-full-row">
                <my-select
                    style="width:50%"
                    v-model="glbdname"
                    :data="glbdList"
                    :props="{value:'bdrowguid',label:'bdname'}"
                    @select="selectPro"
                    placeholder="选择关联标段信息">
                </my-select>
            </el-form-item>

            <el-form-item 
            label="招标项目名称">
                {{form.zbproname}}
            </el-form-item>

            <el-form-item 
            label="标段(包)名称" 
            prop="bdname" 
            :rules="newRule('标段(包)名称', 'required','sensitiveWords')">
                <el-input v-model="form.bdname"></el-input>
            </el-form-item>

            <el-form-item 
            label="标段(包)内容" 
            prop="bdcontent" 
            :rules="newRule('标段(包)内容', 'required','sensitiveWords')" 
            class="table-full-row">
                <ueditor v-model="form.bdcontent" />
            </el-form-item>

            <el-form-item 
            label="标段(包)分类代码" 
            prop="bdtypename" 
            :rules="newRule('标段(包)分类代码', 'required')" 
            class="table-full-row">
                <cascader-bdtype
                v-model="form.bdtypecode"
                2way="text"
                @bdsorname="bdsorname"
                :text.sync="form.bdtypename"
                ></cascader-bdtype>
            </el-form-item>

            <el-form-item 
            v-if="model.hdzj"
            label="住建标段(包)分类代码" 
            prop="hdzjbdtypecode" 
            :rules="newRule('住建标段(包)分类代码', 'required')" 
            class="table-full-row">
                <my-select
                :data="hdzjbdtype"
                v-model="form.hdzjbdtypecode"
                placeholder="请选择住建标段(包)分类代码"
                :props="{label:'text', value:'id'}"
                 2way="text"
                :text.sync="form.hdzjbdtypename"
            ></my-select>
            </el-form-item>

            <el-form-item 
            label="标段(包)投资概算" 
            prop="bdhtgsj" 
            :rules="newRule('标段(包)投资概算', 'required','number')">
                <el-input-number 
                    v-model.number="form.bdhtgsj" 
                    style="width:250px"
                    :min="0"
                    :max="1e+18"
                    @blur="checknum()">
                </el-input-number>万元 人民币
                <my-tag type="danger">
                    请注意单位是(万元),影响平台使用费计算
                </my-tag>
            </el-form-item>

            <el-form-item 
            label="招标文件售价(元)" 
            prop="extzbwjsj" 
            :rules="newRule('招标文件售价', 'required','number')"
            v-if="!isZc"
            >
                <el-input-number 
                v-model.number="form.extzbwjsj" 
                :min="0"
                :max="1e+18"
                style="width:250px"
                :disabled="(model.iszj&&form.bdcode==null)||model.islq||(form.is_ptsf==0&&form.adddwcode=='E0000001674')">
                </el-input-number>
            </el-form-item>
        
            <el-form-item 
            label="投标人缴费平台" 
            prop="is_ptsf" 
            :rules="newRule('投标人缴费平台', 'required')" 
            v-if="form.adddwcode=='E0000001674'&&!isZc">
                <el-radio-group v-model="form.is_ptsf" @change="ptchange()">
                    <el-radio label="1">{{ptPlaceholder}}</el-radio>
                    <el-radio label="0">公共资源交易中心</el-radio>
                </el-radio-group>
            </el-form-item>

            <el-form-item 
            label="图纸押金(元)" 
            prop="exttzyj" 
            :rules="newRule('图纸押金', 'required','number')" 
            :class="{'table-full-row': form.extzbwjsj===0}"
            v-if="!isZc">
                <el-input-number 
                    v-model.number="form.exttzyj" 
                    :min="0"
                    :max="1e+18"
                    style="width:250px"
                    :disabled="(model.iszj&&form.bdcode==null)||model.islq">
                </el-input-number>
                
            </el-form-item>

            <el-form-item 
            label="标书款支付方式" 
            prop="extzbwjzffs" 
            :rules="proRule" 
            v-if="form.extzbwjsj!==0&&!isZc">
                <my-checkbox
                    model-str
                    str-spliter=","
                    v-model="form.extzbwjzffs"
                    :data="payList"
                    :props="{label:'typename',value:'type'}"
                ></my-checkbox>
            </el-form-item>

            <el-form-item 
            label="缴费说明" 
            prop="extjfsm"
            class="table-full-row"
            :rules="newRule('标段(包)内容','sensitiveWords')" 
            v-if="!isZc">
                <el-input 
                v-model="form.extjfsm" 
                type="textarea" 
                maxlength="200"
                show-word-limit
                :autosize="{ minRows: 4, maxRows: 10}">
                </el-input>
                <my-tag>
                    可选填，投标人缴纳标书款时可见，如缴费方式等
                </my-tag>
            </el-form-item>

            <el-form-item 
            label="投标人资格条件" 
            prop="tbrzgtj" 
            :rules="newRule('投标人资格条件', 'required','sensitiveWords')" 
            class="table-full-row">
                <ueditor v-model="form.tbrzgtj" />
            </el-form-item>

            <el-form-item 
            v-if="model.hdzj&&!isZc"
            label="保证金金额(元)" 
            prop="exttbbzj" 
            :rules="newRule('保证金金额', 'required','number')">
                <el-input-number 
                    v-model.number="form.exttbbzj" 
                    :min="0"
                    :max="1e+18"
                    size="medium">
                </el-input-number>
            </el-form-item>

            <el-form-item 
            v-if="model.hdzj&&!isZc"
            label="是否评定分离" 
            prop="extstr1" 
            :rules="proRulePdfl">
                <el-radio-group v-model="form.extstr1" @change="ptchange()">
                    <el-radio label="1">是</el-radio>
                    <el-radio label="0">否</el-radio>
                </el-radio-group>
            </el-form-item>

            <el-form-item
            v-if="model.sfbm"
            label="报名资料"
            class="table-full-row"
            prop="tbrzgtj">
                <bm-file
                v-model="model.datalist"
                :bmzlguid="form.bmzlguid"></bm-file>
            </el-form-item>

            <template slot="btn" slot-scope="scope">
                <el-button 
                @click="saveHandler(1, scope.submitHandler)" 
                type="primary" 
                icon="el-icon-circle-check">
                    提交
                </el-button>
                <el-button 
                @click="saveHandler(0, scope.submitHandler)" 
                type="warning" 
                icon="el-icon-remove-outline">
                    暂存
                </el-button>

                <el-button 
                icon="el-icon-circle-close" 
                @click="scope.cancleHandler">
                    取消
                </el-button>

                <div style="margin-top:10px">
                    <my-tag type="danger">招标公告未发布前，如发现问题可在左侧菜单：综合管理-修改审核状态 处自行退回。</my-tag>
                </div>
            </template>
        </my-form>
        
    </div>
</template>

<script>
import FORM_PAGE_MIXIN from '@views/mixins/form-page'

import BmFile from './components/bm-file'
import CascaderBdtype from '@views/bidding/components/cascader-bdtype'
import InputOver10w from "@views/bidding/components/input-over-10w";

export default {
    mixins: [FORM_PAGE_MIXIN],
    components: { BmFile,CascaderBdtype,InputOver10w },
    data() {
        
        return{
            
            form:{
               
            },
            model:{},
            bdtypeProps:{
                lazy: true,
                lazyLoad: this.lazyLoad
            },
            payList:[],
            payData:[],
            copy:'',
            getUrl:'',
            isZc:false,//是否是政采项目
            ptPlaceholder: window._config.title2,
            hdzjbdtype:[],
            glbdList:[],//关联标段列表
            glbdname:'',
            glbdShow:true,
        }
    },
    computed: {
        proRule(){
            var rule = this.newRule('标书款支付方式', 'required')
            rule[0].message = '请勾选标书款支付方式'
            return rule
        },
        proRulePdfl(){
            var rule = this.newRule('是否评定分离', 'required')
            rule[0].message = '请勾选是否评定分离'
            return rule
        },
    },
    watch: {
        
    },
    methods: {
       
        // 投资概算
        checknum(){
            var that = this
            if(that.form.bdhtgsj>100000){
                that.$confirm('您输入的投资概算为：'+that.form.bdhtgsj+'<strong color="red">万元</strong>人民币，请确认是否正确', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '否定,改为'+that.form.bdhtgsj/10000+'万元人民币',
                    dangerouslyUseHTMLString: true,
                    callback:function (value,instance) {
                        if(value=='cancel'){
                            that.form.bdhtgsj = that.form.bdhtgsj/10000
                        }

                    }
                });
            }
        },
        // 交费平台
        ptchange(){
            if(this.form.is_ptsf=='0'){
                ShowMsg("不在"+this.ptPlaceholder+"缴费的招标文件售价设置为0元！")
                this.form.extzbwjsj='0';
            }
        },
        // 保存
        saveHandler(type, cb){
            this.form.extzbwjzffs = this.form.extzbwjzffs.toString()
            this.form.bzcode = '156';
            this.form.bztext = '人民币';
            this.form.jedwcode = '2';
            this.form.jedwname = '万元';
            this.form.shbj = type;
            cb && cb();
        },
        // 选择标段分类 
        bdsorname(val){
            this.form.bdtypename = val
        },
        // 将选择的标段信息赋值到form
        selectPro(val){
            this.form.bdname = val.bdname;
            this.form.relationcode = val.bdrowguid;
        }
    },
    created() {
        var that = this   
        that.copy = that.getQuery('copy')
        // 获取关联标段信息
        that.$get(`${that.getGetters('ageUrl')}/tender/bidsection.json`,{
            zbprocode:that.getQuery('procode')
        }, data => {
            that.projectShow = true;
            if(data){
                that.glbdList = data;
            }
            
        }) 
        // 初始化
        that.jspInit(`${that.getGetters('ageUrl')}/revision/FangAn/BiaoDuan/queryEditPageData.json`, {
            procode:that.getQuery('procode'),
            id:that.getQuery('id'),
            copy:that.copy
        }, data => {
            that.model = data
            that.form = data.model
            that.hdzjbdtype = data.hdzjbdtype
            that.payList = data.payList
            that.payList.push({type:'9',typename:'线下支付'})
                
            // 全选支付选择
            if(that.form.bdcode===null&&(that.copy==='0'||!that.form.extzbwjzffs)){
                that.payList.forEach(function(item){
                    that.payData.push(item.type)
                })
                that.form.extzbwjzffs = that.payData.splice(',').toString()
            }else{
                if(!that.form.extzbwjzffs){
                    that.payList.forEach(function(item){
                        that.payData.push(item.type)
                    })
                    that.form.extzbwjzffs = that.payData.splice(',').toString()
                }else{
                    
                }
            }
            
            // 复制标段
            if(that.copy==='1'){
                that.form.bdcode = ''
                that.form.bdname = ''
            }
            // 判断是否政采
            if(that.getQuery('isZc')==='true'){
                that.getUrl = `${that.getGetters('ageUrl')}/revision/FangAn/BiaoDuan/government/info.json`
            }else{
                that.getUrl = `${that.getGetters('ageUrl')}/revision/FangAn/BiaoDuan/info.json`
            }
            
        });
        // 判断是否编辑
        if(that.getQuery('id')){
            this.glbdShow = false;
        }
        
    },
    mounted() {
        console.log(this.dispatch)
        if(this.getQuery('isZc')==='false'){
            this.isZc = false
        }else{
            this.isZc = true
        }
    }
}
</script>

<style scoped lang="scss">

</style>
